(() => {
  'use strict';

  // Run in normal theme previews as well as the editor. The visible label
  // identifies these values as simulated stock, not actual inventory.
  if (customElements.get('nuve-stock-demo')) return;

  customElements.define('nuve-stock-demo', class extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-demo-stock-message]');
      if (!this.message) return;

      try {
        this.counts = JSON.parse(this.querySelector('[data-demo-stock-variants]')?.textContent || '{}');
      } catch (error) {
        return;
      }

      this.controller?.abort();
      this.controller = new AbortController();
      this.update(this.dataset.variantId);

      document.addEventListener('variant:change', (event) => {
        if (event.target?.getAttribute('id') !== this.dataset.formId) return;
        this.update(event.detail?.variant?.id);
      }, { signal: this.controller.signal });

      // New elements initialize automatically after the theme replaces the
      // variant-picker block, including when a combined product is selected.
      this.hidden = false;
      this.setAttribute('data-demo-active', '');
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    update(variantId) {
      if (!variantId) {
        this.message.textContent = 'Choose an available combination';
        return;
      }

      const key = String(variantId);
      let count = this.counts[key];

      // Handle variants outside Shopify's rendered variant list without
      // fetching data or changing any product, cart or inventory values.
      if (!Number.isInteger(count) || count < 1 || count > 18) {
        let hash = 0;
        for (const character of `${this.dataset.productId}:${key}`) {
          hash = (Math.imul(hash, 31) + character.charCodeAt(0)) >>> 0;
        }
        count = (hash % 18) + 1;
      }

      this.dataset.variantId = key;
      this.message.textContent = `Only ${count} in Stock`;
    }
  });
})();
